<app-title-bar [title]='"Lista de Capas"' [icon]="'layers'"></app-title-bar>
<div id="divLayersList" class="LayersList">
</div>